jQuery(document).ready(function() {
  jQuery('.tmenu_item_has_child').hover(
         function(){ jQuery(this).addClass('tmenu_item_active') },
         function(){ jQuery(this).removeClass('tmenu_item_active') }
  )


  if (jQuery('#Linklist-collections-womens-fashion1')) {
    jQuery('#Linklist-collections-womens-fashion1').append(
            jQuery(document.createElement('a')).prop({
                target: '_self',
		        class: 'women-round-link',
                href: '/collections/womens-dresses',
            })
    );
    jQuery('.women-round-link').append(
            jQuery(document.createElement('span')).prop({
		        class: 'tmenu_item_text',
                innerText: 'Wool Dresses'
            })
    );
  };
  if (jQuery('#Linklist-collections-men2')) {
    jQuery('#Linklist-collections-men2').append(
            jQuery(document.createElement('a')).prop({
                target: '_self',
		        class: 'men-round-link',
                href: '/collections/mens-sports',
            })
    );
    jQuery('.men-round-link').append(
            jQuery(document.createElement('span')).prop({
		        class: 'tmenu_item_text',
                innerText: 'Men Sports'
            })
    );
  };


  if (jQuery('#Sublinklist-collections-womens-fashion1-collections-womens-ready-to-wear2')) {
    jQuery('#Sublinklist-collections-womens-fashion1-collections-womens-ready-to-wear2').prepend(
            jQuery(document.createElement('a')).prop({
                target: '_self',
		        class: 'women-collection-link',
                href: '/collections/womens-dresses',
            })
    );
  };

  if (jQuery('#Sublinklist-collections-men2-collections-mens-ready-to-wear3')) {
      jQuery('#Sublinklist-collections-men2-collections-mens-ready-to-wear3').prepend(
              jQuery(document.createElement('a')).prop({
                  target: '_self',
  		        class: 'men-collection-link',
                  href: '/collections/mens-sports',
              })
      );
    };
  
});

